import { Banknote, Smartphone, Landmark } from "lucide-react";
import { useLanguage } from "../i18n";

const PaymentBadges = ({ dark = false, testid = "payment-badges" }) => {
  const { t } = useLanguage();
  const pill = dark
    ? "inline-flex items-center gap-1.5 rounded-lg border border-white/20 bg-white/5 px-3 py-1.5 text-xs font-bold text-white/85"
    : "inline-flex items-center gap-1.5 rounded-lg border border-[#E6DEC8] bg-[#FAF6F0] px-3 py-1.5 text-xs font-bold text-[#0D1B2A]";
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid={testid}>
      <span className={pill}>
        <Banknote size={14} className="text-[#1B6B93]" />
        {t.payLabels.cash}
      </span>
      <span className="inline-flex items-center rounded-lg bg-[#1A1F71] px-3 py-1.5 text-[11px] font-black italic tracking-widest text-white">
        VISA
      </span>
      <span className={pill}>
        <Smartphone size={14} className="text-[#00B2E3]" />
        Bizum
      </span>
      <span className={pill}>
        <Landmark size={14} className="text-[#C85A32]" />
        {t.payLabels.transfer}
      </span>
    </div>
  );
};

export default PaymentBadges;
